<template>
<div>
    <loading :show-loading="showLoading" />
    <div class="pc">
        <div class="con-icon"><img src="@/assets/newImages/common/common-icon.png" alt=""></div>
        <div class="content">
            <!-- 标题 -->
            <div class="con-head">
                <p>热门资讯</p>
                <div class="search">
                    <input type="text" placeholder="请输入您感兴趣的资讯" @keyup.enter="search" v-model="keywords" placeholder-style="color:#AAAAAA">
                    <div @click="search">
                        <img src="@/assets/newImages/hotNews/search.png" alt="">
                    </div>
                </div>
            </div>
            <!-- 内容 -->
            <div class="con-news" :style="{height:pageHeight}" >
                <div class="news-one" v-if="newsList.length>0">
                    <div class="one" v-for="(item,index) in newsList" :key="index" @click="jump(item.url, item.title, item.product_tag, item.industry_tag)">
                        <p class="date">{{item.pushTimeYear}}.{{item.pushTimeDay}}</p>
                        <div class="one-img"><img :src="item.coverImageRealPath" alt=""></div>
                        <div class="one-message">
                            <p class="title">{{item.title}}</p>
                            <p class="text">{{item.summary2}}</p>
                            <div class="see">
                                <img src="@/assets/newImages/home/icon-right9.png" alt="">
                                <img src="@/assets/newImages/hotNews/icon-right-red.png" alt="">
                                <p>立即查看</p></div>
                        </div>
                    </div>
                </div>
                <div class="news-one flexCenter" :style="{height:pageHeight}" style="background: #FFFFFF;" v-if="newsList.length==0&&keywords">
                    <p style="color:gray;font-size:24px;margin:auto;">暂无您要搜索的内容</p>
                </div>
                <div class="news-one flexCenter" :style="{height:pageHeight}" style="background: #FFFFFF;" v-if="newsList.length==0&&!keywords">
                    <p style="color:gray;font-size:24px;margin:auto;">敬请期待</p>
                </div>
            </div>
        </div>
    </div>
    <div class="wap">
        <div class="page-img"><img src="@/assets/newImages/common/navWap/page-img.png" alt=""></div>
        <div class="content">
            <!-- 标题 -->
            <div class="con-header"><p>热门资讯</p></div>
            <div class="search-div">
                <input type="text" placeholder="请输入您感兴趣的资讯" v-model="keywords" placeholder-style="color:#AAAAAA">
                <div @click="search" class="img">
                    <img src="@/assets/newImages/hotNews/search.png" alt="">
                </div>
            </div>
            <!-- 内容 -->
            <div class="con-news" v-if="newsList.length>0">
                <div class="one" v-for="(item,index) in newsList" :key="index" @click="jump(item.url, item.title, item.product_tag, item.industry_tag)">
                    <p class="date">{{item.pushTimeYear}}.{{item.pushTimeDay}}</p>
                    <div class="one-img"><img :src="item.coverImageRealPath" alt=""></div>
                    <div class="one-message"> <p class="title">{{item.title}}</p></div>
                </div>
            </div>
            <div class="con-news-one" v-if="newsList.length==0&&keywords">
                <p>暂无您要搜索的内容</p>
            </div>
            <div class="con-news-one" v-if="newsList.length==0&&!keywords">
                <p>敬请期待</p>
            </div>
        </div>
    </div>
</div>
    
</template>
<script>
import api from '../api';
import { timestampToYear, timestampToMonth, timestampToDay } from '@/utils/tool';
import loading from 'components/loading';
export default {
    components: {
        loading
    },
    data(){
        return{ 
            pageHeight:'',
            height:document.documentElement.clientHeight,
            width:document.documentElement.clientWidth,
            newsList:[],
            newsListOri:[],
            keywords: '',
            showLoading: true,
        }
    },
    created(){
        this.pageHeight = this.height-184/1920*this.width-63/1920*this.width+"px"
        this.getNewsList();
    },
    mounted(){
        let self = this;
        this.$nextTick(() => {
            self.showLoading = false;
        })
    },
    methods:{
        jump(url, title='', product_tag='', industry_tag=''){

            // 埋码
            this.$maima.news_page_news_click(title, product_tag, industry_tag);

            if(url){
                window.open(url);
            }
            return;
        },
        search(){
            if(this.keywords){
                let temp = [];
                this.newsListOri.map(item=>{
                    if(item.title.indexOf(this.keywords) != -1){
                        temp.push(item);
                    }
                })
                this.newsList = temp;

                // 埋码
                this.$maima.news_page_search_click(this.keywords);
            }else{
                this.newsList = this.newsListOri;
            }
        },
        getNewsList(){
            let that = this;
            api.getNewsList()
            .then(res=>{
                res.map(item=>{
                    item.pushTimeYear = timestampToYear(item.pushTime);
                    item.pushTimeDay = timestampToMonth(item.pushTime) + '.' + timestampToDay(item.pushTime);
                    item.summary2 = item.summary.length > 36 ? item.summary.substr(0, 35) + '...' : item.summary;
                    item.title = item.title.length > 45 ? item.title.substr(0, 44) + '...' : item.title;
                });
                that.newsList = res;
                that.newsListOri = res;
            })
            .catch(err=>{
                that.$store.commit('showGlobalToast', {status: true, time: 6000, msg: '当前网络较差，建议更换网络环境并重新载入。'});
            });
        },
    }
}
</script>

<style scoped lang="scss">
*{
    padding: 0;
    margin: 0;
    box-sizing: border-box;
}
.pc{
    position: relative;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    background: url('../assets/newImages/common/common-bg.png')no-repeat center center/cover;
    .content{
        width: pxToVw(1600);
        margin: pxToVw(0) pxToVw(0) 0 pxToVw(233);
        padding-top: pxToVw(49);
        position: relative;
        z-index: 2;
        .con-head{
            width: 100%;
            height: pxToVw(115);
            text-align: left;
            display: flex;
            justify-content: space-between;
            p{  
                width: pxToVw(351);
                height: pxToVw(115);
                padding: pxToVw(36) 0 0 pxToVw(92);
                font-size: pxToVw(43);
                font-family: "FZLT-blackBold";
                color: #FFF;
                line-height: pxToVw(52);
                background: url("../assets/newImages/common/common-title-bg.png")no-repeat center center/cover;
            }
            .search{
                margin: pxToVw(84) pxToVw(18) pxToVw(0) pxToVw(0);
                width: pxToVw(316);
                height: pxToVw(39);
                background: #FFFFFF;
                box-shadow: 0px 0px pxToVw(24) 0px rgba(231,231,231,0.5);
                border-radius: pxToVw(20);
                display: flex;
                align-items: center;
                padding:pxToVw(0) pxToVw(0) pxToVw(0) pxToVw(33);
                // margin-top: pxToVw(-60);
                input{
                    width: pxToVw(225);
                    border: none;
                    outline: none;
                    font-size: pxToVw(19);
                    font-weight: normal;
                    color: #0a0a0a;
                    line-height: pxToVw(23);
                    &::placeholder{
                        color: #AAAAAA;
                    }
                }
                input::-webkit-search-cancel-button{
                    display: none;
                }
                input[type=text]::-ms-clear{
                    display: none;
                }
                div{
                    width: pxToVw(21);
                    height: pxToVw(21);
                    margin-left: pxToVw(11);
                    cursor: pointer;
                    z-index: 2;
                    img{
                        width: 100%;
                        height: 100%;
                    }
                }
            }
        }
        .con-news{
            // width: pxToVw(1520);
            // height: pxToVw(761);
            margin: pxToVw(20) pxToVw(0) pxToVw(0) pxToVw(63);
            padding-right: pxToVw(15);
            // padding-bottom: pxToVw(15);
            // background: red;
            overflow-y: scroll;
            scrollbar-width: none;
            -ms-overflow-style: none;
             /*滚动条样式*/
            &::-webkit-scrollbar{
                width: pxToVw(3);
                // height: pxToVw(761);
                background: none; 
            }
            &::-webkit-scrollbar-track{
                background: none;
            }
            &::-webkit-scrollbar-thumb{
                background: #DDDDDD;
                // border: pxToVw(5) solid rgba(221, 221, 221, 0.6);
            }
            .news-one{
            // width: pxToVw(1520);
                height: auto;
                flex-wrap: wrap;
                display: flex;
                background: RGBA(253, 253, 253, .9);
                // background: red;
                box-shadow: 0px 0px pxToVw(27) 0px rgba(231,231,231,0.5);
                padding: pxToVw(15) 0 pxToVw(48) pxToVw(45);
                border-radius: pxToVw(2);
                // justify-content: space-around;
                .one{
                    width: pxToVw(329);
                    height: pxToVw(520);
                    background: #FFFFFF;
                    box-shadow: 0px 0px pxToVw(10) 0px rgba(235,235,235,0.5);
                    border-radius: pxToVw(1);
                    margin: pxToVw(33) pxToVw(33) 0 pxToVw(0);
                    cursor: pointer;
                    .date{
                        // width: 100%;
                        // height: pxToVw(73);
                        padding-left: pxToVw(15);
                        font-size: pxToVw(20);
                        font-weight: 900;
                        color: #666666;
                        line-height: pxToVw(81);
                        font-family: "ABlack";
                    }
                    .one-img{
                        width: pxToVw(329);
                        height: pxToVw(188);
                        img{
                            width: pxToVw(329);
                            height: pxToVw(188);
                        }
                    }
                    .one-message{
                        padding: pxToVw(27) pxToVw(17) pxToVw(0) pxToVw(15);
                        .title{
                            height: pxToVw(96);
                            font-size: pxToVw(19);
                            font-family: "FZLT-blackLittle";
                            font-weight: normal;
                            color: #333333;
                            line-height: pxToVw(32);
                            overflow: hidden;
                            display: -webkit-box;
                            -webkit-line-clamp: 3;
                            -webkit-box-orient: vertical;
                        }
                        .text{
                            // width: pxToVw(298);
                            height: pxToVw(53);
                            font-size: pxToVw(16);
                            font-family: "FZLT-black";
                            font-weight: normal;
                            color: #999999;
                            line-height: pxToVw(29);
                            margin-top: pxToVw(9);
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 2;
                            -webkit-box-orient: vertical;
                        }
                        .see{
                            margin-top: pxToVw(24);
                            display: flex;
                            align-items: center;
                            flex-direction: row-reverse;
                            cursor: pointer;
                            p{
                                font-size: pxToVw(16);
                                font-weight: normal;
                                font-family: "FZLT-black";
                                color: #999999;
                                line-height: pxToVw(19);
                            }
                            img{
                                width: pxToVw(16);
                                height: pxToVw(13);
                                margin-left: pxToVw(9);
                                &:nth-child(2){
                                    display: none;
                                }
                            }
                            &:hover{
                                p{
                                    color: #C50819;
                                    
                                }
                                img{
                                    &:nth-child(1){
                                        display: none;
                                    }
                                    &:nth-child(2){
                                        display: block;
                                    }
                                }
                            }
                        }
                        
                    }
                }
                
            }
        }
    }
    .con-icon{
        position: absolute;
        right: 0;
        bottom: 0;
        width: pxToVw(480);
        height: pxToVw(403);
        img{
            width: pxToVw(480);
            height: pxToVw(403);
        }
    }
}
.wap{
    display: none;
}
@media screen and (max-width:767px) {
    .pc{
        display: none;
    }
    .wap{
        display: block;
        position: relative;
        z-index: 2;
        width: 100%;
        height: auto;
        min-height: 100vh;
        padding: 10vw 0 13.3vw;
        background: url('../assets/newImages/common/navWap/page-bg.png')no-repeat center center/cover;
        .page-img{
            position: absolute;
            bottom: 0;
            z-index: -1;
            right: 0;
            width: 38.1vw;
            height: 25.1vw;
            img{
                width: 38.1vw;
                height: 25.1vw;
            }
        }
        .content{
            width: 100%;
            border-top: 1px solid #DDDDDD;
            .con-header{
                height: 12.3vw;
                margin: 3.2vw 0 2.3vw;
                width: 100%;
                text-align: left;
                p{  
                    width: 37.6vw;
                    height: 12.3vw;
                    margin-left: -2.8vw;
                    padding: 4.1vw 0 0 10vw;
                    font-size: 4.3vw;
                    font-family: "FZLT-blackBold";
                    color: #FFF;
                    line-height: 5.2vw;
                    background: url("../assets/newImages/common/navWap/page-title.png") no-repeat center center/cover;
                }
            }
            .search-div{
                margin: 0 auto;
                width: 90.9vw;
                height: 8vw;
                background: rgba($color: #FFF, $alpha: 0.9);
                box-shadow: 0 0 4vw 0 rgba(231,231,231,0.5);
                border-radius: 4vw;
                padding: 0 2.6vw 0 5.2vw;
                display: flex;
                justify-content: space-between;
                align-items: center;
                input{
                    width: 70vw;
                    border: none;
                    height: 8vw;
                    font-size: 3.2vw;
                    line-height: 8vw;
                    color: #333;
                    &::placeholder{
                        color: #AAAAAA;
                    }
                }
                input::-webkit-search-cancel-button{
                    display: none;
                }
                input[type=text]::-ms-clear{
                    display: none;
                }
                .img{
                    width: 8vw;
                    height: 8vw;
                    padding: 2.5vw;
                    img{
                        vertical-align: top;
                        width: 3.1vw;
                        height: 3.1vw;
                    }
                }
            }
            .con-news{
                width: 100%;
                padding: 2.1vw 4.5vw 0 4.8vw;
                display: flex;
                flex-wrap: wrap;
                .one{
                    width: 43.7vw;
                    height: 58.7vw;
                    background: #FFFFFF;
                    box-shadow: 0 0 1.1vw 0 rgba(235,235,235,0.5);
                    margin: 0 3.2vw 2.7vw 0;
                    &:nth-child(2n){
                        margin-right: 0;
                    }
                    .date{
                        height: 9.6vw;
                        padding-left: 2vw;
                        font-size:3.5vw;
                        font-weight: 900;
                        color: #666666;
                        line-height: 9.6vw;
                        font-family: "ABlack";
                    }
                    .one-img{
                        width: 43.7vw;
                        height: 24.7vw;
                        img{
                            width: 43.7vw;
                            height: 24.7vw;
                        }
                    }
                    .one-message{
                        height: 24.4vw;
                        padding: 3.1vw 2.3vw 0 2vw;
                        .title{
                            font-size: 3.5vw;
                            color: #333333;
                            line-height: 5.3vw;
                            overflow: hidden;
                            display: -webkit-box;
                            -webkit-line-clamp: 3;
                            -webkit-box-orient: vertical;
                        }
                    }
                }
            }
            .con-news-one{
                margin:2.1vw auto 0;
                display:flex;
                width: 90.7vw;
                background:#fff;
                height:50vw;
                p{
                    color:gray;
                    font-size:16px;
                    margin:auto;
                }
            }
        }
    }
}
</style>